import React, { memo } from 'react'
import { Skeleton } from 'antd'

const _TranscriptionLineSkeleton = ({ lineWidth }) => (
  <div
    style={{
        display: 'flex',
    }}
  >
    <Skeleton
      active
      paragraph={false}
      style={{
        width: '36px',
        marginRight: '10px'
      }}
    />
    <Skeleton
      active
      paragraph={false}
      style={{
        width: lineWidth,
        height: '20px',
        paddingTop: 0,
        marginBottom: 0
      }}
    />
  </div>
)

export const TranscriptionLineSkeleton = memo(_TranscriptionLineSkeleton)
